import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value, currency = 'SEK') {
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatNumber(value, decimals = 0) {
  return new Intl.NumberFormat('sv-SE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('sv-SE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

// Default values for Swedish forest economy
// Sources: Skogsstyrelsen Q4 2025, SLU Riksskogstaxeringen
// Note: Growth rates are for Svealand (middle range). Use regional defaults for specific regions.
export const defaultTreeSpecies = {
  gran: {
    species: 'gran',
    growth_managed: 5.5,      // Svealand average (m³/ha/year)
    growth_neglected: 4.2,    // ~25% lower without management
    price_timber: 1197,       // SEK/m³fub - Skogsstyrelsen Q4 2025
    price_pulpwood: 663,      // SEK/m³sub - Skogsstyrelsen Q4 2025
    clearing_cost: 2500,      // SEK/ha
    planting_cost: 8500,      // SEK/ha (increased 2025)
    thinning_cost: 290,       // SEK/m³
  },
  tall: {
    species: 'tall',
    growth_managed: 4.8,      // Svealand average
    growth_neglected: 3.6,
    price_timber: 995,        // SEK/m³sub - Skogsstyrelsen Q4 2025
    price_pulpwood: 663,      // Same as coniferous pulpwood
    clearing_cost: 2500,
    planting_cost: 8000,
    thinning_cost: 280,
  },
  bjork: {
    species: 'bjork',
    growth_managed: 3.2,      // Svealand average
    growth_neglected: 2.4,
    price_timber: 620,        // Estimated based on market
    price_pulpwood: 655,      // SEK/m³sub - Skogsstyrelsen Q4 2025 (lövmassaved)
    clearing_cost: 2200,
    planting_cost: 7000,
    thinning_cost: 260,
  },
};

export const defaultRiskScenario = {
  storm_probability: 0.02,
  storm_damage: 0.3,
  bark_beetle_probability: 0.01,
  bark_beetle_damage: 0.2,
  fire_probability: 0.005,
  fire_damage: 0.5,
};

// Chart colors matching design guidelines
export const chartColors = {
  profit: '#4A7043',
  loss: '#BC4749',
  growth: '#D4A373',
  baseline: '#6B7280',
  primary: '#2F5233',
  secondary: '#8B5E3C',
};
